import React from 'react'
import { BsTwitter, BsInstagram, BsLinkedin} from "react-icons/bs";
// import { } from "react-icons/li"
const SocialMedia = () => {
  return (
    <div className='app__social'>
        <div>
            <a href='https://instagram.com/Sbieey' target="_blank" without rel="noreferrer"><BsInstagram /></a>
        </div>
        <div>
           <a href= 'https://twitter.com/Sbiiey' target="_blank" without rel="noreferrer"><BsTwitter /></a>
        </div>
        <div>
           <a  href='https://www.linkedin.com/in/muhammad-kabiru-suleiman-2647531b5/' target="_blank" without rel="noreferrer"><BsLinkedin /></a>
        </div>
    </div>
  )
}

export default SocialMedia